/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 10/02/22
 */

export const isNullish = (value: unknown): value is null | undefined => value === null || value === undefined;
